var AgrimarketApp = angular.module('AgrimarketApp', ['ngRoute', 'angucomplete', 'angucomplete-alt', 'AgrimarketControllers', 'AgrimarketFactories', 'AgrimarketServices', 'ngResource',
    'ngSanitize',
    'ngRoute',
    'angularFileUpload']);
var AgrimarketFactories = angular.module('AgrimarketFactories', []);
var AgrimarketDirectives = angular.module('AgrimarketDirectives', []);
var AgrimarketServices = angular.module('AgrimarketServices', ['AgrimarketFactories']);
var AgrimarketControllers = angular.module('AgrimarketControllers', ['AgrimarketFactories', 'AgrimarketDirectives', 'AgrimarketServices', 'dirPagination']);

window.mobileAndTabletcheck = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

window.redirectToMobile = function (urlIndex, urlMobile) {
    if (window.location.href.indexOf('#/resetPassword') > 0)
        window.location.href = window.location.href.replace(urlIndex + '#', urlMobile);
    else {
        var newHref = window.location.href.replace(urlIndex.replace("index.html", "") + '#', urlMobile).replace("/?", "?");
        var urlSplitted = newHref.split('?');
        var params = "";
        if (urlSplitted.length > 0)
            params = urlSplitted[1];
        if (newHref.toLowerCase().indexOf('logintiers=') > 0 && newHref.toLowerCase().indexOf('jeton=') > 0 && (newHref.toLowerCase().indexOf('logincerelio') > 0 || newHref.toLowerCase().indexOf('loginuac') < 0)) {
            if (params)
                window.location.href = urlMobile + '/loginCerelio?' + params;
        }
        else {
            if (params && newHref.indexOf(urlMobile) > 0)
                window.location.href = newHref;
            else
                window.location.href = urlMobile;
        }
    }
};

window.fullReload = function (version){
    window.location.href = window.location.href + "#" + version;
    window.location.reload();
};

AgrimarketFactories.factory('HttpInterceptor', function ($q, $location, $rootScope) {
    return {
        'request': function (config) {
            return config;
        },

        'requestError': function (rejection) {
            return $q.reject(rejection);
        },

        'response': function (response) {
            return response;
        },

        'responseError': function (rejection) {
            // redirection pour les pertes de session du header request 
            // code status 401 : Unauthorized
            // 0 : NSHTTPURLResponse : aucune réponse
            if ($location.$$path.indexOf("login") == -1 && rejection.status !== 200 && rejection.status !== 400 && rejection.status !== 503 && rejection.status !== 404 && rejection.status !== 501) {
                if (sessionStorage.getItem("hasRefresh") !== "true")
                    sessionStorage.clear();
                $location.path("/login");
            } else if (rejection.status === 503) {
                if (!sessionStorage.getItem("IdUserAdmin") || sessionStorage.getItem("IdUserAdmin") === "undefined" || sessionStorage.getItem("IdUserAdmin") === "null")
                    sessionStorage.clear();

                $rootScope.isLogged = false;
                $location.path("/siteUnavailable");
            } else if (rejection.status === 501) {
                console.log('rejection.status === 501');
                $location.path("/disableSubscription");
            } else if ($location.$$path.indexOf("login") == -1 && rejection.status === 400 && sessionStorage.getItem("hasRefresh") === "true") {
                sessionStorage.clear();
                $location.path("/login");
            }
            return $q.reject(rejection);
        }
    };
});

AgrimarketApp.config([
    '$routeProvider', '$httpProvider',
    function ($routeProvider, $httpProvider) {

        $httpProvider.defaults.useXDomain = true;

        $httpProvider.defaults.headers.common["accept"] = "application/json"; // type de fichier reçu

        delete $httpProvider.defaults.headers.common["X-Requested-With"];

        window.routes =
        {
            //Acces via BackDoor Agrimarket 
            '/backdoor/': {
                templateUrl: 'app/Partials/backoffice/backdoor/backdoorConnexion.html',
                controller: 'backdoorController',
                requireLogin: false
            },

            //indique que l'utilisateur doit s'authentifier pour y accéder
            '/backdoor/profile': {
                templateUrl: 'app/Partials/backoffice/backdoor/profileBackdoor.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/siteUnavailable': {
                templateUrl: 'app/Partials/siteUnavailable.html',
                controller: 'siteUnavailableController',
                requireLogin: false
            },
            '/login/': {
                templateUrl: 'app/Partials/login.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginHash/:paramForLoginHash?/:hashForLoginHash?/:page?/:showMenu?/:idLanguage?': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginEditMode/:redirect?': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/refresh/': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginCerelio/:loginTiers?/:jeton?': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginUAC/:loginTiers?/:jeton?/:AdresseIpSlc?': {
                templateUrl: 'app/Partials/login.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/access/:paramConnectorUrlReferrer?/:hideMenu?': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginOuifield': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/loginConnectorSso/:token?/:param?/:page?/:showMenu?': {
                templateUrl: 'blank.html',
                controller: 'loginController',
                requireLogin: false
            },
            '/UnsubscribeNewsMarketInfo/': {
                templateUrl: 'app/Partials/UnsubscribeNewsMarketInfo.html',
                controller: 'UnsubscribeNewsMarketInfoController',
                requireLogin: false
            },
            '/disconnect': {
                templateUrl: 'blank.html',
                controller: 'DisconnectController',
                requireLogin: false
            },
            '/validateCGU': {
                templateUrl: 'app/Partials/ValidateCGU.html',
                controller: 'ValidateCGUController',
                requireLogin: false
            },
            '/disableSubscription': {
                templateUrl: 'app/Partials/disableSubscription.html',
                controller: 'disableSubscriptionController',
                requireLogin: false
            },
            '/user/commitments/view/:commitmentView': {
                templateUrl: 'app/Partials/frontoffice/commitments/commitments.html',
                controller: 'commitmentsController',
                requireLogin: true,
                resolve: {
                    colonnesTypeCommitments: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(26);
                        }
                    ],
                    colonnesContractTypeCommitmentAndProduct: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(27);
                        }
                    ],
                    colonnesContractProduct: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(36);
                        }
                    ],
                    colonnesContractTypeCommitment: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(37);
                        }
                    ],
                    colonnesListFixationsByIdCommitment: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(84);
                        }
                    ]
                }
            },
            '/user/commitmentsAll': {
                templateUrl: 'app/Partials/frontoffice/commitments/commitmentsAll.html',
                controller: 'commitmentsAllController',
                requireLogin: true,
                resolve: {
                    colonnesCropProductTonnages: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(82);
                        }
                    ]
                }
            },
            '/resetPassword/:keyPassword?': {
                templateUrl: 'app/Partials/resetPassword.html',
                controller: 'resetPasswordController',
                requireLogin: false
            },
            '/user/offers/view/:typeOffer/:idContractCommitment?/:quantity?/:targetPrice?/:idTypeFixationOnlyTargetPrice?/:idFirstComponentContractOrContractBase?': {
                templateUrl: 'app/Partials/frontoffice/offer/list/offersMonitoring.html',
                controller: 'userOfferController',
                requireLogin: true,
                resolve: {
                    colonnesOffersFirmUser: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(22);
                        }
                    ],
                    colonnesOffersFirmTc: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(24);
                        }
                    ],
                    colonnesOffersCommitmentUser: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(23);
                        }
                    ],
                    colonnesOffersCommitmentTc: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(25);
                        }
                    ],
                    colonnesOffersOptionUser: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(50);
                        }
                    ],
                    colonnesOffersOptionTc: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(51);
                        }
                    ],
                    colonnesOffersBlankContract: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(97);
                        }
                    ],
                    colonnesOffersCommitmentSurfaceUser: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(110);
                        }
                    ],
                    colonnesOffersCommitmentSurfaceTc: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(111);
                        }
                    ],
                    colonnesOffersMultiCropsUser: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(116);
                        }
                    ],
                    colonnesOffersMultiCropsTc: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(117);
                        }
                    ],
                }
            },
            '/admin/offers/:idStatus?': {
                templateUrl: 'app/Partials/backoffice/offers.html',
                controller: 'offersController',
                requireLogin: true
            },
            '/user/subscribe/contractBase/:idContractCommitment?/:idContractFuture?/:quantity?/:targetPrice?': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractBase/subscribe.html',
                controller: 'subscribeContractBaseController',
                requireLogin: true,
                resolve: {
                    colonnesContractTypeCommitmentAndProduct: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(27);
                        }
                    ],
                    colonnesContractFutureCompatibles: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(56);
                        }
                    ]
                }
            },
            '/user/subscribe/contractFirm/:idContractCommitment?/:idTypeFixation?/:idContractBase?/:quantity?/:targetPrice?': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractFirm/subscribe.html',
                controller: 'userSubscribeContractFirmController',
                requireLogin: true,
                resolve: {
                    colonnesContractTypeCommitmentAndProduct: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(27);
                        }
                    ],
                    colonnesContractBaseCompatibles: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(55);
                        }
                    ]
                }
            },
            '/user/subscribe/contractCommitment': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractCommitment/subscribe.html',
                controller: 'userSubscribeContractCommitmentController',
                requireLogin: true
            },
            '/user/subscribe/contractSurfaceCommitment': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractSurfaceCommitment/subscribe.html',
                controller: 'userSubscribeContractSurfaceCommitmentController',
                requireLogin: true
            },
            '/user/subscribe/contractoption': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractOption/subscribeOption.html',
                controller: 'subscribeContractOptionController',
                requireLogin: true,
                resolve: {
                    colonnesStrikeOption: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(119);
                        }
                    ]
                }
            },
            '/user/subscribe/contractBlank': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractBlank/subscribe.html',
                controller: 'userSubscribeContractBlankController',
                requireLogin: true
            },
            '/user/subscribe/contractMultiCrops': {
                templateUrl: 'app/Partials/frontoffice/subscribe/contractMultiCrops/subscribe.html',
                controller: 'subscribeContractMultiCropsController',
                requireLogin: true
            },
            '/user/contracts/firm/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/contracts/firm/monitoring.html',
                controller: 'userContractsFirmMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(29);
                        }
                    ],
                    colonnesPriced: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(30);
                        }
                    ],
                    colonnesCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(31);
                        }
                    ],
                    colonnesPending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(60);
                        }
                    ],
                    colonnesDelayedSigning: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(101);
                        }
                    ]
                }
            },
            '/user/contracts/commitment/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/contracts/commitment/monitoring.html',
                controller: 'userContractsCommitmentMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(32);
                        }
                    ]
                }
            },
            '/user/contracts/surfaceCommitment/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/contracts/surfaceCommitment/monitoring.html',
                controller: 'userContractsSurfaceCommitmentMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsSurfaceCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(108);
                        }
                    ]
                }
            },
            '/user/contracts/base/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/contracts/base/monitoring.html',
                controller: 'userContractsBaseMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsBaseValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(66);
                        }
                    ],
                    colonnesContractsBasePending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(67);
                        }
                    ],
                    colonnesContractsBasePriced: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(68);
                        }
                    ],
                    colonnesContractsBaseCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(69);
                        }
                    ]
                }
            },
            '/user/contracts/option/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/contracts/option/monitoring.html',
                controller: 'userContractsOptionMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsOptionExpired: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(78);
                        }
                    ],
                    colonnesContractsOptionPending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(79);
                        }
                    ],
                }
            },
            '/user/supply/delivery': {
                templateUrl: 'app/Partials/frontoffice/supply/delivery.html',
                controller: 'deliveryController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(96);
                        }
                    ]
                }
            },
            '/user/supply/commands/:idExtCommand?': {
                templateUrl: 'app/Partials/frontoffice/supply/commands.html',
                controller: 'commandsController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(95);
                        }
                    ]
                }
            },
            '/user/supply/request/asking': {
                templateUrl: 'app/Partials/frontoffice/supply/requestPrices.html',
                controller: 'requestPricesController',
                requireLogin: true,
                resolve: {
                    colonnesCart: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(10);
                        }
                    ]
                }
            },
            '/user/supply/request/asked': {
                templateUrl: 'app/Partials/frontoffice/supply/monitoringRequest.html',
                controller: 'monitoringRequestController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(11);
                        }
                    ]
                }
            },
            '/user/smsalert': {
                templateUrl: 'app/Partials/frontoffice/smsalert/smsalert.html',
                controller: 'userSmsAlertController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(86);
                        }
                    ]
                }
            },
            '/admin/offer/createoffer/:idoffer': {
                templateUrl: 'app/Partials/backoffice/createoffer.html',
                controller: 'createofferController',
                requireLogin: true
            },
            '/admin/offer/dupliquer/:idoffer': {
                templateUrl: 'app/Partials/backoffice/createoffer.html',
                controller: 'createofferController',
                requireLogin: true
            },
            '/admin/offer/builtPriceManager/:idoffer': {
                templateUrl: 'app/Partials/backoffice/manage/builtPriceManager.html',
                controller: 'builtPriceManagerController',
                requireLogin: true
            },
            '/admin/contracts/firm/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/firm/monitoring.html',
                controller: 'contractsFirmMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesValidatedNotCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(16);
                        }
                    ],
                    colonnesValidatedCovered: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(17);
                        }
                    ],
                    colonnesValidatedPendingCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(18);
                        }
                    ],
                    colonnesCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(19);
                        }
                    ],
                    colonnesPricedNotCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(20);
                        }
                    ],
                    colonnesPricedPendingCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(21);
                        }
                    ],
                    colonnesPendingNotCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(52);
                        }
                    ],
                    colonnesPendingCovered: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(53);
                        }
                    ],
                    colonnesPendingPendingCover: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(54);
                        }
                    ],
                    colonnesToValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(98);
                        }
                    ],
                    columnsDelayedSigning: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(103);
                        }
                    ],
                }
            },
            '/admin/contracts/builtPrice/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/builtPrice/monitoring.html',
                controller: 'contractsBuiltPriceMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsSubscription: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(104);
                        }
                    ],
                    colonnesContractsObservation: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(105);
                        }
                    ],
                    colonnesContractsFixed: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(106);
                        }
                    ],
                    colonnesContractsCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(107);
                        }
                    ],               
                }
            },
            '/admin/contracts/commitment/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/commitment/monitoring.html',
                controller: 'contractsCommitmentMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(28);
                        }
                    ]
                }
            },
            '/admin/contracts/surfaceCommitment/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/surfaceCommitment/monitoring.html',
                controller: 'contractsSurfaceCommitmentMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsSurfaceCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(112);
                        }
                    ]
                }
            },
            '/admin/contracts/base/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/base/monitoring.html',
                controller: 'contractsBaseMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsBaseValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(62);
                        }
                    ],
                    colonnesContractsBasePending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(63);
                        }
                    ],
                    colonnesContractsBasePriced: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(64);
                        }
                    ],
                    colonnesContractsBaseCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(65);
                        }
                    ]
                }
            },
            '/admin/contracts/option/view/:typeContract': {
                templateUrl: 'app/Partials/backoffice/contracts/option/monitoring.html',
                controller: 'contractsOptionMonitoringController',
                requireLogin: true,
                resolve: {
                    colonnesContractsOptionExpired: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(75);
                        }
                    ],
                    colonnesContractsOptionPending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(76);
                        }
                    ],
                    colonnesContractsOptionDetails: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(77);
                        }
                    ]
                }
            },
            '/admin/editorial/view/mails/:idLanguage?/:viewMode?': {
                templateUrl: 'app/Partials/backoffice/editorial/editorialMail.html',
                controller: 'editorialMailController',
                requireLogin: true
            },
            '/admin/editorial/view/contracts/:idLanguage?': {
                templateUrl: 'app/Partials/backoffice/editorial/editorialContract.html',
                controller: 'editorialContractController',
                requireLogin: true
            },
            '/admin/editorial/comMarketInfo/:msgConf?': {
                templateUrl: 'app/Partials/backoffice/editorial/comMarketInfo.html',
                controller: 'comMarketInfoController',
                requireLogin: true,
                resolve: {
                    colonnesCommunicationMarketInfo: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(39);
                        }
                    ]
                }
            },
            '/admin/editorial/saveComMarketInfo/:id?': {
                templateUrl: 'app/Partials/backoffice/editorial/saveComMarketInfo.html',
                controller: 'saveComMarketInfoController',
                requireLogin: true
            },
            '/admin/editorial/alertMail': {
                templateUrl: 'app/Partials/backoffice/editorial/alertMail.html',
                controller: 'alertMailController',
                requireLogin: true,
                resolve: {
                    colonnesAlertMail: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(114);
                        }
                    ]
                }
            },
            '/admin/editorial/createAlertMail/:idAlertMail': {
                templateUrl: 'app/Partials/backoffice/editorial/createAlertMail.html',
                controller: 'createAlertMailController',
                requireLogin: true
            },
            '/admin/editorial/duplicateAlertMail/:idAlertMail': {
                templateUrl: 'app/Partials/backoffice/editorial/createAlertMail.html',
                controller: 'createAlertMailController',
                requireLogin: true
            },
            '/admin/contents/notifications': {
                templateUrl: 'app/Partials/backoffice/contents/notifications/notifications.html',
                controller: 'notificationsController',
                requireLogin: true,
                resolve: {
                    colonnesNotifications: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(100);
                        }
                    ]
                }
            },
            '/admin/contents/saveNotification/:idNotification?': {
                templateUrl: 'app/Partials/backoffice/contents/notifications/saveNotification.html',
                controller: 'saveNotificationController',
                requireLogin: true
            },
            '/admin/editorial/editionMobile': {
                templateUrl: 'app/partials/backoffice/editorial/editionMobile.html',
                controller: 'editorialMobileController',
                requireLogin: true
            },
            '/admin/editorial/editTemplateContract/:idtemplate': {
                templateUrl: 'app/partials/backoffice/editorial/viewsMode/editTemplateContract.html',
                controller: 'editTemplateContractController',
                requireLogin: true
            },
            '/admin/editorial/editTemplateMail/:idTypeTemplateMail/:idRole/:idLanguage/:viewMode?': {
                templateUrl: 'app/partials/backoffice/editorial/viewsMode/editTemplateMail.html',
                controller: 'editTemplateMailController',
                requireLogin: true
            },
            '/admin/parameters/crops': {
                templateUrl: 'app/Partials/backoffice/parameters/crops.html',
                controller: 'cropsController',
                requireLogin: true
            },
            '/admin/parameters/global': {
                templateUrl: 'app/Partials/backoffice/parameters/global.html',
                controller: 'globalController',
                requireLogin: true

            },
            '/admin/parameters/products': {
                templateUrl: 'app/Partials/backoffice/parameters/products.html',
                controller: 'productsController',
                requireLogin: true

            },
            '/admin/parameters/homePageApplicationMobiles': {
                templateUrl: 'app/Partials/backoffice/parameters/homePageApplicationMobiles.html',
                controller: 'homePageApplicationMobilesController',
                requireLogin: true

            },
            '/admin/parameters/compagnies': {
                templateUrl: 'app/Partials/backoffice/parameters/compagnies.html',
                controller: 'compagniesController',
                requireLogin: true

            },
            '/admin/parameters/closeDay': {
                templateUrl: 'app/Partials/backoffice/parameters/closeDay.html',
                controller: 'closeDayController',
                requireLogin: true

            },
            '/admin/routing/cover/view/:typeView': {
                templateUrl: 'app/Partials/backoffice/routing/cover.html',
                controller: 'coverController',
                requireLogin: true
            },
            '/admin/routing/portfolio/view/:typeView': {
                templateUrl: 'app/Partials/backoffice/routing/portfolio.html',
                controller: 'portfolioController',
                requireLogin: true,
                resolve: {
                    contractsColumns: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(93);
                        }
                    ],
                    ordersColumns: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(94);
                        }
                    ]
                }
            },
            '/admin/dataManagment/weatherData': {
                templateUrl: 'app/Partials/backoffice/dataManagment/weatherData.html',
                controller: 'weatherDataController',
                requireLogin: true,
                resolve: {
                    colonnesAccuWeatherCall: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(115);
                        }
                    ]
                }
            },
            '/admin/parameters/conditions/view/:typeView': {
                templateUrl: 'app/Partials/backoffice/parameters/conditions.html',
                controller: 'conditionsController',
                requireLogin: true
            },
            '/admin/parameters/categoryoffer': {
                templateUrl: 'app/Partials/backoffice/parameters/categoryOffer.html',
                controller: 'categoryOfferController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(92);
                        }
                    ]
                }
            },
            '/admin/contents/quotes': {
                templateUrl: 'app/Partials/backoffice/contents/quotes.html',
                controller: 'quoteAdminController',
                requireLogin: true
            },
            '/admin/manage/users': {
                templateUrl: 'app/Partials/backoffice/manage/users.html',
                controller: 'manageUsersController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(7);
                        }
                    ]
                }
            },
            '/admin/manage/groupusers': {
                templateUrl: 'app/Partials/backoffice/manage/groupusers.html',
                controller: 'manageGroupUsersController',
                requireLogin: true
            },
            '/admin/manage/tc': {
                templateUrl: 'app/Partials/backoffice/manage/users.html',
                controller: 'manageUsersController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(8);
                        }
                    ]
                }
            },
            '/admin/manage/admins': {
                templateUrl: 'app/Partials/backoffice/manage/admins.html',
                controller: '',
                requireLogin: true
            },
            '/tc/manage/users': {
                templateUrl: 'app/Partials/frontoffice/manage/usersOfTC.html',
                controller: 'manageUsersOfTcController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(9);
                        }
                    ]
                }
            },

            '/tc/contracts/firm/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/manage/contractsOfTcUsers/monitoring.html',
                controller: 'manageContractsOfTcUsersController',
                requireLogin: true,
                resolve: {
                    columnsValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(12);
                        }
                    ],
                    columnsPriced: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(13);
                        }
                    ],
                    columnsCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(14);
                        }
                    ],
                    columnsPending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(61);
                        }
                    ],
                    columnsDelayedSigning: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(102);
                        }
                    ],
                }
            },

            '/tc/contracts/base/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/manage/base/monitoring.html',
                controller: 'manageContractsBaseOfTcUserController',
                requireLogin: true,
                resolve: {
                    colonnesContractsBaseValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(70);
                        }
                    ],
                    colonnesContractsBasePending: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(71);
                        }
                    ],
                    colonnesContractsBasePriced: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(72);
                        }
                    ],
                    colonnesContractsBaseCanceled: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(73);
                        }
                    ]
                }
            },

            '/tc/contracts/commitment/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/manage/commitment/monitoring.html',
                controller: 'manageContractsCommitmentOfTcUserController',
                requireLogin: false,
                resolve: {
                    colonnesContractsCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(74);
                        }
                    ]
                }
            },

            '/tc/contracts/surfaceCommitment/view/:typeContract': {
                templateUrl: 'app/Partials/frontoffice/manage/surfaceCommitment/monitoring.html',
                controller: 'manageContractsSurfaceCommitmentOfTcUserController',
                requireLogin: false,
                resolve: {
                    colonnesContractsSurfaceCommitmentValidated: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(109);
                        }
                    ]
                }
            },


            '/user/dashboard': {
                templateUrl: 'app/Partials/frontoffice/dashboard.html',
                controller: 'dashboardController',
                requireLogin: true
            },
            '/tc/dashboard': {
                templateUrl: 'app/Partials/frontoffice/dashboard.html',
                controller: 'dashboardController',
                requireLogin: true
            },
            '/user/userManagement/:typeTab?': {
                templateUrl: 'app/Partials/frontoffice/user/userManagement.html',
                controller: 'userManagementController',
                requireLogin: true
            },

            /*** Mes comptes ***/
            '/user/accounts/outstandings': {
                templateUrl: 'app/Partials/frontoffice/accounts/outstandings.html',
                controller: 'outstandingsController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(4);
                        }
                    ]
                }
            },
            '/user/accounts/bills': {
                templateUrl: 'app/Partials/frontoffice/accounts/bills.html',
                controller: 'billsController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(5);
                        }
                    ]
                }
            },
            '/user/accounts/accountStatement': {
                templateUrl: 'app/Partials/frontoffice/documentOrigin.html',
                controller: 'accountstatementController',
                requireLogin: true
            },
            /*** Fin de Mes comptes ***/

            /*** Gestion de contenus ***/
            '/admin/contents/news/': {
                templateUrl: 'app/Partials/backoffice/contents/news/news.html',
                controller: 'newsController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(2);
                        }
                    ]
                }
            },
            '/admin/contents/news/saveNews/:idnews': {
                templateUrl: 'app/partials/backoffice/contents/news/saveNews.html',
                controller: 'saveNewsController',
                requireLogin: true
            },
            '/admin/contents/fluxrss/': {
                templateUrl: 'app/Partials/backoffice/contents/flux.html',
                controller: 'fluxrssController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(1);
                        }
                    ]
                }
            },
            '/admin/contents/video/': {
                templateUrl: 'app/Partials/backoffice/contents/video.html',
                controller: 'videoController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(47);
                        }
                    ]
                }
            },
            '/admin/contents/content/': {
                templateUrl: 'app/Partials/backoffice/contents/content/contents.html',
                controller: 'contentsController',
                requireLogin: true
            },
            '/admin/contents/content/savePage/:indexMenu/:indexPage': {
                templateUrl: 'app/partials/backoffice/contents/content/savePage.html',
                controller: 'savePageController',
                requireLogin: true
            },
            '/user/content/:IdMenu?/:IdPage': {
                templateUrl: 'app/Partials/frontoffice/content.html',
                controller: 'contentUserController',
                requireLogin: true
            },
            '/tc/content/:IdMenu?/:IdPage': {
                templateUrl: 'app/Partials/frontoffice/content.html',
                controller: 'contentUserController',
                requireLogin: true
            },
            '/admin/contents/infoMarketHashtagri/view/:typeView': {
                templateUrl: 'app/Partials/backoffice/contents/infoMarketHashtagri/infoMarketHashtagri.html',
                controller: 'infoMarketHashtagriController',
                requireLogin: true
            },
            '/admin/contents/infoMarketHashtagri/saveContentInfoMarket/:idWritingContentInfoMarket': {
                templateUrl: 'app/partials/backoffice/contents/infoMarketHashtagri/saveContentInfoMarket.html',
                controller: 'saveContentInfoMarketController',
                requireLogin: true
            },

            '/admin/contents/carouselpicture/': {
                templateUrl: 'app/Partials/backoffice/contents/carouselPicture.html',
                controller: 'carouselPictureController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(91);
                        }
                    ]
                }
            },
            '/admin/ceremisDashboard': {
                templateUrl: 'app/partials/backoffice/ceremisDashboard.html',
                controller: 'ceremisDashboardController',
                requireLogin: true
            },

            '/admin/contents/contacts': {
                templateUrl: 'app/Partials/backoffice/contents/contacts.html',
                controller: 'contactsController',
                requireLogin: true
            },

            '/admin/contents/dashboard': {
                templateUrl: 'app/Partials/backoffice/contents/dashboard.html',
                controller: 'dashboardController',
                requireLogin: true
            },

            /*** Fin de Gestion de contenus ***/

            /*** Gestion de formulaires dynamiques ***/
            '/admin/form/dynamicforms': {
                templateUrl: 'app/Partials/backoffice/form/dynamicForms.html',
                controller: 'dynamicFormsController',
                requireLogin: true
            },
            '/admin/form/publishingdynamicforms': {
                templateUrl: 'app/Partials/backoffice/form/publishingDynamicForms.html',
                controller: 'dynamicFormsController',
                requireLogin: true
            },
            '/user/form/dynamicFormsToComplete': {
                templateUrl: 'app/Partials/frontoffice/form/dynamicFormsToComplete.html',
                controller: 'dynamicFormsController',
                requireLogin: true
            },
            '/user/form/dynamicFormsCompleted': {
                templateUrl: 'app/Partials/frontoffice/form/dynamicFormsCompleted.html',
                controller: 'dynamicFormsController',
                requireLogin: true
            },
            /*** Fin Gestion de formulaires dynamiques ***/

            '/user/contributions/': {
                templateUrl: 'app/Partials/frontoffice/contributions/contributions.html',
                controller: 'contributionsController',
                requireLogin: true,
                resolve: {
                    colonnes: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(6);
                        }
                    ]
                }
            },
            '/user/documents/': {
                templateUrl: 'app/Partials/frontoffice/document.html',
                controller: 'documentsController',
                requireLogin: true
            },
            '/user/marketinfos/': {
                templateUrl: 'app/Partials/frontoffice/marketinfos/marketinfos.html',
                controller: 'marketinfostUserController',
                requireLogin: true
            },
            '/user/quotesFilter/': {
                templateUrl: 'app/Partials/frontoffice/marketinfos/quotesFilter.html',
                controller: 'marketinfostUserController',
                requireLogin: true
            },            
            '/user/redirectOnOuiField/': {
                templateUrl: 'app/Partials/frontoffice/redirectOuiField.html',
                controller: 'redirectOuiFieldController',
                requireLogin: true
            },
            '/common/messenger/reception/': {
                templateUrl: 'app/Partials/common/messenger/messenger.html',
                controller: 'messengerController',
                requireLogin: true,
                resolve: {
                    colonnesMessageSended: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(33);
                        }
                    ],
                    colonnesMessageReceived: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(34);
                        }
                    ]
                }
            },
            '/common/messenger/sended/': {
                templateUrl: 'app/Partials/common/messenger/messenger.html',
                controller: 'messengerController',
                requireLogin: true,
                resolve: {
                    colonnesMessageSended: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(33);
                        }
                    ],
                    colonnesMessageReceived: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(34);
                        }
                    ]
                }
            },
            '/common/messenger/read/:IdMessage': {
                templateUrl: 'app/Partials/common/messenger/messenger.html',
                controller: 'messengerController',
                requireLogin: true,
                resolve: {
                    colonnesMessageSended: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(33);
                        }
                    ],
                    colonnesMessageReceived: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(34);
                        }
                    ]
                }
            },
            '/common/messenger/newmessage/:IdMessage?': {
                templateUrl: 'app/Partials/common/messenger/messenger.html',
                controller: 'messengerController',
                requireLogin: true,
                resolve: {
                    colonnesMessageSended: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(33);
                        }
                    ],
                    colonnesMessageReceived: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(34);
                        }
                    ]
                }
            },
            '/common/quotes/:withBtnBack?': {
                templateUrl: 'app/Partials/common/quote/quotes.html',
                controller: 'quoteController',
                requireLogin: true,
                resolve: {
                    colonnesQuote: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(35);
                        }
                    ],
                    colonnesQuoteWithoutRealTime: [
                        'userTableService', function (userTableService) {
                            return userTableService.GetById(38);
                        }
                    ]
                }
            },
            '/tc/nomoduleactivated': {
                templateUrl: 'app/Partials/frontoffice/nomoduleactivated.html',
                requireLogin: true,
            },

            /************** TEST SOCKET ********************/
            '/testsocket/:ActionToOrder': {
                templateUrl: 'app/Partials/TestSocket/testsocket.html',
                controller: 'testsocketController',
                requireLogin: false
            }

        };

        //this loads up our routes dynamically from the previous object 
        for (var path in window.routes) {
            $routeProvider.when(path, window.routes[path]);
        }
        $routeProvider.otherwise({ redirectTo: '/login' });

        $httpProvider.interceptors.push('HttpInterceptor');

    }
]).run(function ($rootScope, currentUserFactory, configurationFactory, $location, $interval, messengerService, $timeout, enumFactory, $sce, versionService) {
    
    $rootScope.buildReactAppUrl = function (path, args) {
        if (path.length > 0 && path[0] !== "/")
            path = "/" + path;

        var params = args !== undefined ? Object.keys(args).map(function(str) { return str + "=" + args[str]; }) : [];

        if (sessionStorage.getItem("modeEdition") === "true") {
            params.push("modeEdition=1");
        }

        var strParams = params.join("&");

        if (strParams.length > 0)
            strParams = "?" + strParams;

        if ($location.host() === "localhost")
            return $sce.trustAsResourceUrl("http://localhost:12999/v2" + path + strParams);

        return "/v2" + path + strParams;
    };
    
    window.addEventListener('message', function (e) {
        var message = '';

        try {
            message = JSON.parse(e.data);
        } catch (ex) {
            return;
        }

        if (message.action == "guidRequest"){
            var json = JSON.parse(sessionStorage.getItem("LOG"));
            if (json && json.token)
                e.source.postMessage(JSON.stringify({ type:"guid", guid: json.token }), "*");
        }
        else if (message.action == "configRequest"){
            e.source.postMessage(JSON.stringify({ type:"config", config: configurationFactory }), "*");
        }
        else if (message.action == "sessionRequest" && currentUserFactory.User){
            e.source.postMessage(JSON.stringify(
                { type:"session", idUser : (currentUserFactory.User.IdClientSelectedFromTc ? currentUserFactory.User.IdClientSelectedFromTc : currentUserFactory.User.IdUser), idCrop : $rootScope.crop.IdCrop, idConnection : $rootScope.idConnectionLogged }
            ), "*");
        }        
        else if (message.action == "redirect"){
            window.location.assign(window.location.protocol + "//" + window.location.host + "/#" + message.url);
        }
        else if (message.action == "setTitle"){
            var reactTitle = this.document.getElementById("reactTitle");
            if(reactTitle)
            {
                reactTitle.innerText = message.title;
            }
        }
        else if (message.action == "setCrop"){
            $rootScope.crop.IdCrop = message.idCrop != 0 ? message.idCrop : $rootScope.crop.IdCrop;
        }
        else if (message.action =="goToSubscribeDelayedSigning"){
            $rootScope.isTcSigningForUser = currentUserFactory.User.IdRole === enumFactory.Roles.TC;
            $rootScope.goToDelayedSigning = true;
            $rootScope.idContractForDelayedSigning = message.idContract;
            if (message.idTypeContract == enumFactory.TypeContract.Ferme)
                window.location.assign(window.location.protocol + "//" + window.location.host + "/#/user/subscribe/contractFirm/");
            else if (message.idTypeContract == enumFactory.TypeContract.ContratVierge)
                window.location.assign(window.location.protocol + "//" + window.location.host + "/#/user/subscribe/contractBlank/");
        }
        else if (message.action =="goToSubscribeBase"){
            $rootScope.idOfferSelected = message.idOffer;
            $rootScope.idExpirySelected = message.idOfferExpiry;
            $rootScope.idTypeOrderSelected = message.isSold ? enumFactory.TypeOrders.Vente.IdTypeOrder : enumFactory.TypeOrders.Prixobjectif.IdTypeOrder;
            $rootScope.idTypeCommitmentSelected = null;
            window.location.assign(window.location.protocol + "//" + window.location.host + "/#/user/subscribe/contractBase//"+ message.idContract);
        }
        else if (message.action =="goToSubscribeFirm"){
            $rootScope.idOfferSelected = message.idOffer;
            $rootScope.idExpirySelected = message.idOfferExpiry;
            $rootScope.idTypeOrderSelected = message.isSold ? enumFactory.TypeOrders.Vente.IdTypeOrder : enumFactory.TypeOrders.Prixobjectif.IdTypeOrder;
            $rootScope.idTypeCommitmentSelected = null;
            window.location.assign(window.location.protocol + "//" + window.location.host + "/#/user/subscribe/contractFirm//2/"+ message.idContractBase);
        }
    });

    versionService.CheckIfUpdateAvailable();

    if (mobileAndTabletcheck() && configurationFactory.Url.hasOwnProperty("Mobile") && configurationFactory.Url.Mobile)
        redirectToMobile(configurationFactory.Url.Index, configurationFactory.Url.Mobile);
    else {
        var googleAnalytics = window.googleAnalytics ? window.googleAnalytics : "";
        gtag('config', googleAnalytics);

        $rootScope.$on('$routeChangeSuccess', function (event) {
            gtag('event', 'page_view', {
                page_title: $location.$$path,
                page_location: $location.$$absUrl,
                page_path: $location.$$path
            });
        });

        $(window).on('beforeunload', function (e) {
            if (!sessionStorage.getItem("referrer")) {
                if (sessionStorage.getItem("LOG")) {
                    sessionStorage.setItem("hasRefresh", true);
                    sessionStorage.removeItem("hasValidateCGU");
                }
                else {
                    $location.path("/login");
                }
            }
        });

        $rootScope.goTo = function (path) {
            $location.path(path);
        };

        $rootScope.goToEditMode = function (redirect) {
            sessionStorage.setItem("IdUserAdmin", $rootScope.User.IdUser);
            sessionStorage.setItem("IdUser", $rootScope.DefaultUserEditionMode);
            sessionStorage.setItem("modeEdition", true);
            $location.path("/loginEditMode/" + redirect);
        };

        $rootScope.goToEditModeTc = function () {
            sessionStorage.setItem("IdUserAdmin", $rootScope.User.IdUser);
            sessionStorage.setItem("IdUser", $rootScope.DefaultTcEditionMode);
            sessionStorage.setItem("modeEdition", true);
            $location.path("/loginEditMode/");
        };

        $rootScope.getPagesByKey = function (key) {
            if ($rootScope.editableMenus) {
                var result = $rootScope.editableMenus.find(function seuil(menu) {
                    return menu.Key === key;
                });

                if (result)
                    return result.PagesEditableVms;
            }
            return [];
        };

        $rootScope.getValueByKey = function (key) {
            if ($rootScope.editableMenus) {
                var result = $rootScope.editableMenus.find(function seuil(menu) {
                    return menu.Key === key;
                });

                if (result)
                    return result.Label;
            }
            return "";
        };

        $rootScope.getPageValueByKey = function (keyMenu, keyPage) {
            if ($rootScope.editableMenus) {
                var result = $rootScope.editableMenus.find(function compare(menu) {
                    return menu.Key === keyMenu;
                });

                if (result) {
                    var r = result.PagesEditableVms.find(function c(page) {
                        return page.Key === keyPage;
                    });

                    if (r !== null) {
                        return r.Label;
                    }
                }
            }
            return "";
        };

        //Pour gerer le cas des post qui ne marche pas sous IE9 et moins
        var rv = -1;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
            if (re.exec(ua) !== undefined && re.exec(ua) !== null)
                rv = parseFloat(RegExp.$1);
        }
        if (rv > -1) {
            if (rv <= 9.0) {
                xhook.addWithCredentials = false;
                jQuery.support.cors = true;
                var t = {};
                var urlApi = configurationFactory.Url['Api'].replace("/api/", "");
                t[urlApi] = '/proxy.html';
                xdomain.slaves(t);
                xdomain.debug = true; //Pour afficher le debug dans la console
            }
        }

        var firstLoad = false;

        var eventlocation = $rootScope.$on("$locationChangeStart", function (event, next) {
            // Gestion du bouton retour du navigateur sur la page du resetPassword
            if ($rootScope.currentPath == "/resetPassword" && next.indexOf("/login/") == -1)
                $location.path('/');

            $interval.cancel($rootScope.refreshCotations);
            if ($location.$$path == "/resetPassword"){
                $rootScope.currentPath = $location.$$path;
            }
            else if (currentUserFactory.User && $location.$$path != "/login" && !sessionStorage.getItem("referrer") && $location.$$path != "/siteUnavailable" && $location.$$path != "/disableSubscription" && $location.$$path != '/disconnect' && $location.$$path.indexOf('/loginEditMode/') == -1 && $location.$$path.indexOf('/loginUAC/') == -1 && $location.$$path.indexOf('/loginCerelio/') == -1 && $location.$$path.indexOf('/loginHash/') == -1 && $location.$$path !== "/validateCGU") {
                if (currentUserFactory.User.Role.toLowerCase() == "tc" ||
                    $location.$$path.toLowerCase().indexOf(currentUserFactory.User.Role.toLowerCase()) >= 0 ||
                    $location.$$path.toLowerCase().indexOf("common") >= 0) {
                    //Permet la navigation avec la flèche pour les connexion backdoor (profile TC)
                    if ((($location.$$path.toLowerCase() === "/backdoor/profile") || ($location.$$path.toLowerCase() === "/backdoor/")) && sessionStorage.getItem("LOG_AVIV")) {
                        sessionStorage.removeItem("LOG");
                        $location.$$path = "/backdoor/profile";
                        $rootScope.currentPath = $location.$$path;
                        sessionStorage.setItem("currentPath", $location.$$path);
                        $location.path($location.$$path);
                    } else {
                        $rootScope.currentPath = $location.$$path;
                        if ($location.$$path !== "/") {
                            /*if ($rootScope.paramBDisableSubscription && $location.$$path.includes("/user/offers/view")) {
                                sessionStorage.setItem("currentPath", "/disableSubscription");
                                $location.path("/disableSubscription");
                            } else {*/
                            sessionStorage.setItem("currentPath", $location.$$path);
                            //}
                        }
                        if ($rootScope.Modules.ModuleMessagerie.Active) {
                            messengerService.GetNbMessage(function (data) {
                                $rootScope.nbmessage = data;
                            });
                        }

                        for (var i in window.routes) {
                            if (next.indexOf(i) != -1) {
                                if (window.routes[i].requireLogin && (!currentUserFactory && !currentUserFactory.User)) {
                                    $location.path('/');
                                }
                            }
                        }
                    }
                } else {
                    //Permet la navigation avec la flèche pour les connexion backdoor (Profile User && Admin)
                    if ((($location.$$path.toLowerCase() === "/backdoor/profile") || ($location.$$path.toLowerCase() === "/backdoor/")) && sessionStorage.getItem("LOG_AVIV")) {
                        sessionStorage.removeItem("LOG");
                        $location.$$path = "/backdoor/profile";
                        $rootScope.currentPath = $location.$$path;
                        if ($location.$$path !== "/") {
                            sessionStorage.setItem("currentPath", $location.$$path);
                        }
                        $location.path($location.$$path);
                    } else {
                        currentUserFactory.User = null;
                        $location.path('/disconnect');
                    }
                }
            } else if ($location.$$path != "/login/" && !sessionStorage.getItem("referrer") && ($location.$$path != "/siteUnavailable" || $location.$$path === "/siteUnavailable" && sessionStorage.getItem("hasRefresh") === "true") && $location.$$path != "/login" && $location.$$path != '/disconnect' && $location.$$path.indexOf('/loginEditMode/') == -1 && $location.$$path.indexOf('/loginUAC/') == -1 && $location.$$path.indexOf('/loginCerelio/') == -1 && $location.$$path.indexOf('/loginHash/') == -1 && ($location.$$path != "/validateCGU" || $location.$$path === "/validateCGU" && sessionStorage.getItem("hasRefresh") === "true") && ($location.$$path != "/disableSubscription" || $location.$$path === "/disableSubscription" && sessionStorage.getItem("hasRefresh") === "true")) {
                $rootScope.currentPath = $location.$$path;
                if ($location.$$path !== "/") {
                    sessionStorage.setItem("currentPath", $location.$$path);
                }
                var user = JSON.parse(sessionStorage.getItem("LOG"));
                if (user)
                    $location.path('/refresh/');
            }
            else { // Cas ou on l'on fait précédent du navigateur et qu'on ai connecté via un referrer
                if (!firstLoad && sessionStorage.getItem("referrer")) {
                    firstLoad = true;
                    var newPath = "/access/" + sessionStorage.getItem("paramConnectorUrlReferrer") + "/" + sessionStorage.getItem("hideMenu");
                    $location.path(newPath);
                }
            }
        });
    }
});